<template>
  <div style="width: fit-content">
    <div style="display: flex">
      <template v-for="(item, index) in upElementBlocks">
        <div :key="index" class="section form-column" :style="{width: item.width + 'px'}">
          <el-form :disabled="disabled" label-width="135px" label-position="right">
            <span class="title">{{ item.title }}</span>
            <template v-for="elementName in item.elementNames">
              <slot :name="elementName" />
              <template v-if="elementName === 'jobNo'">
                <slot name="saleProductCode" />
                <slot name="fullOrInside" />
              </template>
            </template>
          </el-form>
        </div>
      </template>
    </div>
    <slot name="ticketsInfo" />
  </div>
</template>

<script>
export default {
  name: 'TabBookingFCLUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true },
    disabled: { type: Boolean, default: true }
  },
  computed: {
    upElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 1 && p.name !== 'customerDeliveryInfo' && !p.hide)
    }
  }
}
</script>
